<template>
    <div class="customView-page h-100">
        <!-- <app-buy-sell v-if="tradeBuySell" :buySellType="buySellType"></app-buy-sell> -->
        <div class="topSelect-menu d-flex align-items-center justify-content-between mb-10">
            <div class="leftMenuDrop d-flex align-items-center">
                <!-- <div class="dropdown">
                    <button type="button" class="btn appButton dropdown-toggle" data-toggle="dropdown">
                        Watchlist
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href="#">
                            <span class="its"><feather class="mr-1" size="15px" type="star"></feather> favorites</span> <feather size="15px" type="x"></feather>
                        </a>
                        <a class="dropdown-item" href="#">
                            <span class="its"><feather class="mr-1" size="15px" type="trash-2"></feather> FX Majors</span> <feather size="15px" type="x"></feather>
                        </a>
                        <a class="dropdown-item" href="#">
                            <span class="its"><feather class="mr-1" size="15px" type="trash-2"></feather> Indices</span> <feather size="15px" type="x"></feather>
                        </a>
                        <a class="dropdown-item" href="#"><feather size="15px" type="plus"></feather> Create New Watchlist</a>
                    </div>
                </div>
                <div class="dropdown ml-3">
                    <button type="button" class="btn appButton dropdown-toggle" data-toggle="dropdown">
                        Chart
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href="#"> EURUSD <span>Forex Majors</span></a>
                        <a class="dropdown-item" href="#"> GBPUSD <span>Forex Majors</span></a>
                        <a class="dropdown-item" href="#"> USDJPY <span>Forex Majors</span></a>
                        <a class="dropdown-item" href="#"> EURUSD <span>Forex Majors</span></a>
                        <a class="dropdown-item" href="#"> GBPUSD <span>Forex Majors</span></a>
                        <a class="dropdown-item" href="#"> USDJPY <span>Forex Majors</span></a>
                    </div>
                </div> -->
                <div class="dropdown">
                    <button type="button" class="btn appButton dropdown-toggle" data-toggle="dropdown">
                        Widgets
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href="#" v-for="item,key in widgetsList" @click.prevent="getWidgit(key)">{{item.name}}</a>
                    </div>
                </div>
            </div>
            <div class="rightMenuDrop d-flex align-items-center">
                <div class="inLine-chart" v-if="saveActive()">
                    <button type="button" data-toggle="dropdown" class="appButton height-auto min-80 d-flex align-items-center" @click.stop.prevent="save()"><feather size="16px" class="mr-2" type="upload-cloud"></feather> Save</button>
                </div>
                <div class="toggle-button-cover d-flex align-items-center floating mr-3" :class="floting?'active':' '">
                    <input type="checkbox" id="sdf" v-model="floting"/>
                    <label>
                        <span></span>
                        <p class="fixedTR">fixed</p>
                        <p class="floatingTR">floating</p>
                    </label>
                </div>
                <a href="javascript:void(0)" class="btn appButton justify-content-center mr-3" @click="openCreateWorkSpace()">Add Workspace</a>
                <button type="button" data-toggle="dropdown" class="btn appButton dropdown-toggle">
                    Workspace
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item d-flex align-items-center justify-content-between" href="#" @click.prevent="changeWorkSpace(null)" :class="[{'active': selectedWorkspace.id == null}]">Default</a>
                    <a class="dropdown-item d-flex align-items-center justify-content-between" href="#" @click.prevent="changeWorkSpace(item.id)" v-for="item,index in workSpaceList()" :class="[{'active':item.id == selectedWorkspace.id}]">
                        {{item.name}}
                        <span class="d-flex align-items-center">
                            <span class="wahtchlistDel mr-1 ml-2" title="Save" @click="editWorkspace = item"><feather class="" size="13px" type="edit"></feather> </span>
                            <span class="wahtchlistDel" @click.stop.prevent="deleteWorkspaceId = item.id"><feather size="13px" type="trash-2"></feather> </span>
                        </span>
                    </a>
                </div>
                <!-- <a href="#" class="btn appButton justify-content-center">Custom View</a> -->
            </div>
        </div>
        <div class="position-relative moveableElement">
            <div id="app-custom-view">
                <VueDragResize :parentLimitation="true" :isActive="chkDiv('Watchlist')" @deactivated="onDeact('Watchlist')" :y="getTop('Watchlist')" :x="getLeft('Watchlist')" :w="getWidth('Watchlist')" :h="getHeight('Watchlist')" @clicked="clickeed('Watchlist')" :z="getIndex('Watchlist')" @resizestop="appResize($event,'Watchlist')" @dragstop="appResize($event,'Watchlist')" v-if="isActive('Watchlist')" :isDraggable="isFloating('Watchlist')" :isResizable="isFloating('Watchlist')"  :minw="260" :minh="400" :dragHandle="'.topMazimize'"><!--  dragHandle=".drag" :isDraggable="false" :isResizable="false" :preventActiveBehavior="false" -->
                    <div class="secondary-color resizeWhilist">
                        <div class="topMazimize d-flex align-items-center border-bottom justify-content-between">
                            <p>Watch list</p>
                            <div class="justify-content-end">
                                <a href="#" @click.prevent="maximize('Watchlist')"><feather size="12px" type="maximize-2"></feather></a>
                                <a href="#" @click.prevent="close('Watchlist')"><feather size="12px" type="x"></feather></a>
                            </div>
                        </div>
                        <div class="first-wishlist w-100" @click.prevent.stop="">
                            <app-watchlist :loadChart="loadChart" :mn="mn" v-model="chartKeys"></app-watchlist>
                        </div>
                    </div>
                </VueDragResize>
                <VueDragResize :parentLimitation="true" :isActive="chkDiv('chart')" @deactivated="onDeact('chart')" :y="getTop('chart')" :x="getLeft('chart')" :w="getWidth('chart')" :h="getHeight('chart')" @clicked="clickeed('chart')" :z="getIndex('chart')" @resizestop="appResize($event,'chart')" @dragstop="appResize($event,'chart')" v-if="isActive('chart')" :isDraggable="isFloating('chart')" :isResizable="isFloating('chart')" :minw="694" :minh="375"  :dragHandle="'.topMazimize'">
                    <div class="topMazimize d-flex align-items-center border-bottom justify-content-between">
                        <p>Charts</p>
                        <div class="justify-content-end">
                            <a href="#" @click.prevent="maximize('chart')"><feather size="12px" type="maximize-2"></feather></a>
                            <a href="#" @click.prevent="close('chart')"><feather size="12px" type="x"></feather></a>
                        </div>
                    </div>
                    <trading-view :loadChart="loadChart" :mn="mn" v-model="chartKeys" v-if="!showChart"></trading-view>
                    <chart-iq :loadChart="loadChart" :mn="mn" v-model="chartKeys" v-else></chart-iq>
                </VueDragResize>
                <VueDragResize :parentLimitation="true" :isActive="chkDiv('news')" @deactivated="onDeact('news')" :y="getTop('news')" :x="getLeft('news')" :w="getWidth('news')" :h="getHeight('news')" @clicked="clickeed('news')" :z="getIndex('news')" @resizestop="appResize($event,'news')" @dragstop="appResize($event,'news')" v-if="isActive('news')" :isDraggable="isFloating('news')" :isResizable="isFloating('news')" :minw="300" :minh="350"  :dragHandle="'.topMazimize'">
                    <div class="topMazimize d-flex align-items-center border-bottom justify-content-between">
                        <p>News</p>
                        <div class="justify-content-end">
                            <a href="#" @click.prevent="maximize('news')"><feather size="12px" type="maximize-2"></feather></a>
                            <a href="#" @click.prevent="close('news')"><feather size="12px" type="x"></feather></a>
                        </div>
                    </div>
                    <app-news-section class="newsResize-section scrollbar popIf-scroll h-100"/>
                </VueDragResize>
                <VueDragResize :parentLimitation="true" :isActive="chkDiv('buy_sell')" @deactivated="onDeact('buy_sell')" :y="getTop('buy_sell')" :x="getLeft('buy_sell')" :w="300" :h="399" @clicked="clickeed('buy_sell')" :z="getIndex('buy_sell')" @resizestop="appResize($event,'buy_sell')" @dragstop="appResize($event,'buy_sell')" v-if="isActive('buy_sell')" :isDraggable="isFloating('buy_sell')" :isResizable="false" :minw="300" :minh="399"  :dragHandle="'.topMazimize'"><!-- getWidth('buy_sell') getHeight('buy_sell') isFloating('buy_sell') -->
                    <div>
                        <div class="topMazimize d-flex align-items-center border-bottom justify-content-between">
                            <p>Buy Sell</p>
                            <div class="justify-content-end">
                                <!-- <a href="#" @click.prevent="maximize('buy_sell')"><feather size="12px" type="maximize-2"></feather></a> -->
                                <a href="#" @click.prevent="close('buy_sell')"><feather size="12px" type="x"></feather></a>
                            </div>
                        </div>
                        <div class="tablist-one scrollbar position-absolute buysellRelative">
    		    			<div class="columnTwo-snd"@click="clickeed('buy_sell')">
    		                    <app-buy-sell-tabing :currency_pair="loadChart" v-if="instruments[loadChart]"/>
    				    		<div class="buySell-rightTop" v-else>
    		        				<div class="showModal custom-modal">
    		        					<div class="buySell-popup text-center pt-1 d-block">
    					                    <p class="text-center currencyPath border-bottom px-2">
    					                        <span class="f-14 font-weight-bold">{{loadChart}}</span>
    					                        <span></span>
    					                    </p>
    					                    <ul class="toggleButton d-inline-flex align-items-center justify-content-center">
    					                        <li>
    					                            <a class="redBG" href="javascript:void(0)">{{$t('sell')}} <span></span></a>
    					                        </li>
    					                        <li class="actives">
    					                            <a class="greenBG" href="javascript:void(0)">{{$t('buy')}} <span></span></a>
    					                        </li>
    					                    </ul>
    					                    <div class="mainContent buy">
    					                    	<app-loader/>
    					                   	</div>
    					                </div>
    					            </div>
    					        </div>
    					    </div>
    					</div>
                    </div>
                </VueDragResize>
                <VueDragResize :parentLimitation="true" :isActive="chkDiv('eco_cal')" @deactivated="onDeact('eco_cal')" :y="getTop('eco_cal')" :x="getLeft('eco_cal')" :w="getWidth('eco_cal')" :h="getHeight('eco_cal')" @clicked="clickeed('eco_cal')" :z="getIndex('eco_cal')" @resizestop="appResize($event,'eco_cal')" @dragstop="appResize($event,'eco_cal')" v-if="isActive('eco_cal')" :isDraggable="isFloating('eco_cal')" :isResizable="isFloating('eco_cal')" :minw="300" :minh="350"  :dragHandle="'.topMazimize'">
                    <div class="topMazimize d-flex align-items-center border-bottom justify-content-between">
                        <p>Economic Calendar</p>
                        <div class="justify-content-end">
                            <a href="#" @click.prevent="maximize('eco_cal')"><feather size="12px" type="maximize-2"></feather></a>
                            <a href="#" @click.prevent="close('eco_cal')"><feather size="12px" type="x"></feather></a>
                        </div>
                    </div>
                    <economic-calendar class="newsResize-section scrollbar popIf-scroll h-100"/>
                </VueDragResize>
                <VueDragResize :parentLimitation="true" :isActive="chkDiv('depth')" @deactivated="onDeact('depth')" :y="getTop('depth')" :x="getLeft('depth')" :w="getWidth('depth')" :h="getHeight('depth')" @clicked="clickeed('depth')" :z="getIndex('depth')" @resizestop="appResize($event,'depth')" @dragstop="appResize($event,'depth')" v-if="isActive('depth')" :isDraggable="isFloating('depth')" :isResizable="isFloating('depth')" :minw="280" :minh="200"  :dragHandle="'.topMazimize'">
                    <div class="topMazimize d-flex align-items-center border-bottom justify-content-between">
                        <p>Market Depth <span class="green ml-2">{{loadChart}}</span></p>
                        <div class="justify-content-end">
                            <a href="#" @click.prevent="maximize('depth')"><feather size="12px" type="maximize-2"></feather></a>
                            <a href="#" @click.prevent="close('depth')"><feather size="12px" type="x"></feather></a>
                        </div>
                    </div>
                    <!-- <app-depth-chart class="newsResize-section scrollbar popIf-scroll h-100"/> -->
                    <div class="depthChart">
						<!-- <app-depth-chart :bid="bid" :asks="ask" :ref="'depth_chart'" v-if="orderBook[loadChart] && bid.length && ask.length"  id="depth_chart"></app-depth-chart>
						<no-data class="noData hcalc h-100 d-flex justify-content-center flex-column" v-else text="Opps! <span>no data"/> -->
                        <div class="depthChart table-responsive">
                            <app-depth-chart :bid="bid" :asks="ask" :ref="'depth_chart'" v-if="orderBook[loadChart] && bid.length && ask.length" :size="contractSize" id="depth_chart"></app-depth-chart>
                            <div class="d-flex justify-content-center align-items-start" v-else>
                                <!-- <table class="table depthChartTable border-0" v-if="orderBook[loadChart] && instruments[loadChart]">
                                    <thead>
                                        <tr>
                                            <th>Qty</th>
                                            <th class="text-right">Bid Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in getDepthValue('buy')">
                                            <td>{{item.Quantity}}</td>
                                            <td class="green text-right">{{item.Rate}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <table class="table depthChartTable border-0" v-if="orderBook[loadChart] && instruments[loadChart]">
                                    <thead>
                                        <tr>
                                            <th class="text-left">Ask Price</th>
                                            <th class="text-right">Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in getDepthValue('sell')">
                                            <td class="red">{{item.Rate}}</td>
                                            <td class="text-right">{{item.Quantity}}</td>
                                        </tr>
                                    </tbody>
                                </table> -->
                                <no-data class="noData hcalc h-100 d-flex justify-content-center flex-column align-items-center" text="Opps! <span>no data</span>"/>
                            </div>
                        </div>
				 	</div>
                </VueDragResize>
                <VueDragResize :parentLimitation="true" :isActive="chkDiv('alert')" @deactivated="onDeact('alert')" :y="getTop('alert')" :x="getLeft('alert')" :w="getWidth('alert')" :h="getHeight('alert')" @clicked="clickeed('alert')" :z="getIndex('alert')" @resizestop="appResize($event,'alert')" @dragstop="appResize($event,'alert')" v-if="isActive('alert')" :isDraggable="isFloating('alert')" :isResizable="isFloating('alert')" :minw="300" :minh="350"  :dragHandle="'.topMazimize'">
                    <div class="topMazimize d-flex align-items-center border-bottom justify-content-between">
                        <p>Price Alert</p>
                        <div class="justify-content-end">
                            <a href="#" @click.prevent="maximize('alert')"><feather size="12px" type="maximize-2"></feather></a>
                            <a href="#" @click.prevent="close('alert')"><feather size="12px" type="x"></feather></a>
                        </div>
                    </div>
                    <price-alert-tab class="newsResize-section scrollbar popIf-scroll h-100"/>
                </VueDragResize>
                <VueDragResize :parentLimitation="true" :isActive="chkDiv('position')" @deactivated="onDeact('position')" :y="getTop('position')" :x="getLeft('position')" :w="getWidth('position')" :h="getHeight('position')" @clicked="clickeed('position')" :z="getIndex('position')" @resizestop="appResize($event,'position')" @dragstop="appResize($event,'position')" v-if="isActive('position')" :isDraggable="isFloating('position')" :isResizable="isFloating('position')" :minw="882" :minh="226"  :dragHandle="'.topMazimize'">
                    <position-list class="h-100" :pageLimit="10"></position-list>
                    <!-- <order-list :pageLimit="pageLimit" v-show="order == 'pending'" :order="order"></order-list>
                    <trade-history :pageLimit="pageLimit" v-show="order == 'history'" :order="order"></trade-history>
                    <trade-logs :pageLimit="pageLimit" v-show="order == 'transition-history'" :order="order"></trade-logs> -->
                </VueDragResize>
                <VueDragResize :parentLimitation="true" :isActive="chkDiv('order')" @deactivated="onDeact('order')" :y="getTop('order')" :x="getLeft('order')" :w="getWidth('order')" :h="getHeight('order')" @clicked="clickeed('order')" :z="getIndex('order')" @resizestop="appResize($event,'order')" @dragstop="appResize($event,'order')" v-if="isActive('order')" :isDraggable="isFloating('order')" :isResizable="isFloating('order')" :minw="882" :minh="226"  :dragHandle="'.topMazimize'">
                    <order-list class="h-100" :pageLimit="10"></order-list>
                    <!-- <order-list :pageLimit="pageLimit" v-show="order == 'pending'" :order="order"></order-list>
                    <trade-history :pageLimit="pageLimit" v-show="order == 'history'" :order="order"></trade-history>
                    <trade-logs :pageLimit="pageLimit" v-show="order == 'transition-history'" :order="order"></trade-logs> -->
                </VueDragResize>
                <VueDragResize :parentLimitation="true" :isActive="chkDiv('history')" @deactivated="onDeact('history')" :y="getTop('history')" :x="getLeft('history')" :w="getWidth('history')" :h="getHeight('history')" @clicked="clickeed('history')" :z="getIndex('history')" @resizestop="appResize($event,'history')" @dragstop="appResize($event,'history')" v-if="isActive('history')" :isDraggable="isFloating('history')" :isResizable="isFloating('history')" :minw="882" :minh="226"  :dragHandle="'.topMazimize'">
                    <trade-history class="h-100" :pageLimit="10"></trade-history>
                    <!-- <order-list :pageLimit="pageLimit" v-show="order == 'pending'" :order="order"></order-list>
                    <trade-history :pageLimit="pageLimit" v-show="order == 'history'" :order="order"></trade-history>
                    <trade-logs :pageLimit="pageLimit" v-show="order == 'transition-history'" :order="order"></trade-logs> -->
                </VueDragResize>
                <VueDragResize :parentLimitation="true" :isActive="chkDiv('trade_log')" @deactivated="onDeact('trade_log')" :y="getTop('trade_log')" :x="getLeft('trade_log')" :w="getWidth('trade_log')" :h="getHeight('trade_log')" @clicked="clickeed('trade_log')" :z="getIndex('trade_log')" @resizestop="appResize($event,'trade_log')" @dragstop="appResize($event,'trade_log')" v-if="isActive('trade_log')" :isDraggable="isFloating('trade_log')" :isResizable="isFloating('trade_log')" :minw="882" :minh="226"  :dragHandle="'.topMazimize'">
                    <trade-logs class="h-100" :pageLimit="10"></trade-logs>
                    <!-- <order-list :pageLimit="pageLimit" v-show="order == 'pending'" :order="order"></order-list>
                    <trade-history :pageLimit="pageLimit" v-show="order == 'history'" :order="order"></trade-history>
                    <trade-logs :pageLimit="pageLimit" v-show="order == 'transition-history'" :order="order"></trade-logs> -->
                </VueDragResize>
            </div>
        </div>
        <!--Add workspace-->
        <div class="customFixed-vue darkFadeBG selectWatch-pop" v-if="showCreateWorkSpace">
            <div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
                <app-loader v-if="pageLoader"/>
                <span class="closePOP" @click.prevent="clearCreateWorkSpace()"><feather size="13px" type="x"></feather></span>
                <div class="pop-head-title">
                    <p class="mb-3">New workspace</p>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap" v-if="CheckMaxWorkSpace()">
                    <div class="fields-wrapper">
                        <div class="ppSuccess-icon text-center mt-0 mb-2 d-flex align-items-center justify-content-center">
                            <feather size="28px" type="info"></feather>
                        </div>
                        <h3 class="mb-3">You Can create maximum 5 workspace.</h3>
                    </div>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 updateWrap" v-else-if="!createWorkSpaceSuccess">
                    <div class="form-fields">
                        <h3 class="mb-3" v-if="changeToNewId">Do You want to save this workspace.</h3>
                        <input type="text" class="form-controls" placeholder="Workspace Name" name="workspace" v-model="newWorkSpace" v-validate="'required|max:25'" maxlength="20"/>
                        <span class="text-danger" v-if="submitted && errors.has('workspace')">{{ errors.first('workspace') }}</span>
                        <button class="btn appButton linkBG mx-auto justify-content-center mt-4" @click="addWorkSpace()" :disabled="pageLoader">Create workspace</button>
                        <span class="w-100 text-center  d-flex justify-content-center"><a href="#" class="noAdd d-inline-flex justify-content-center mt-1" v-if="changeToNewId" @click.prevent="changeWorkSpace(changeToNewId,true); clearCreateWorkSpace()">Discard Changes</a></span>
                    </div>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap" v-else>
                    <div class="fields-wrapper">
                        <div class="ppSuccess-icon text-center mt-0 mb-2 d-flex justify-content-center align-items-center">
                            <feather size="28px" type="check-circle"></feather>
                        </div>
                        <h3 class="mb-3 green">New workspace has been Added successfully</h3>
                        <button class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click="clearCreateWorkSpace()">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="customFixed-vue darkFadeBG selectWatch-pop" v-show="saveWorkSpaceCurrent">
            <div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
                <span class="closePOP" @click.prevent="saveWorkSpaceCurrent = false; changeToDefault = null;changeToDefault = false"><feather size="13px" type="x"></feather></span>
                <div class="pop-head-title">
                    <p class="mb-3">Save Workspace</p>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap">
                    <app-loader v-if="pageLoader"/>
                    <div class="form-fields">
                        <p class="mb-3">Are you sure want to Save this Workspace?</p>
                        <a href="#" class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click.prevent="saveCurrent()">Yes</a>
                        <a href="#" class="noAdd" @click.prevent="saveWorkSpaceCurrent = false; changeWorkSpace(changeToNewId,true)" v-if="changeToNewId || changeToDefault">Discard Changes</a>
                        <a href="#" class="noAdd" @click.prevent="saveWorkSpaceCurrent = false" v-else>No</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="customFixed-vue darkFadeBG selectWatch-pop" v-show="Object.keys(editWorkspace).length > 0">
            <div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
                <span class="closePOP" @click.prevent="editWorkspace = {}"><feather size="13px" type="x"></feather></span>
                <div class="pop-head-title">
                    <p class="mb-3">Edit Workspace</p>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap">
                    <app-loader v-if="pageLoader"/>
                    <div class="form-fields">
                        <input type="text" class="form-controls" placeholder="Workspace Name" name="workspace" v-model="editWorkspace.name" v-validate="'required|max:25'" maxlength="25"/>
                        <a href="#" class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click.prevent="editSave()">Submit</a>
                        <a href="#" class="noAdd" @click.prevent="editWorkspace = {}">Cancle</a>
                    </div>
                </div>
            </div>
        </div>
        <!--remove workspace-->
        <div class="customFixed-vue darkFadeBG selectWatch-pop" v-show="deleteWorkspaceId">
            <div class="custom-modal showTabs secondary-color headerTab newsResize openWatchlist">
                <span class="closePOP" @click.prevent="deleteWorkspaceId = null"><feather size="13px" type="x"></feather></span>
                <div class="pop-head-title">
                    <p class="mb-3">Delete Workspace</p>
                </div>
                <div class="topSettingHead position-relative border-bottom p-3 text-center updateWrap">
                    <app-loader v-if="pageLoader"/>
                    <div class="form-fields">
                        <p class="mb-3">Are you sure want to delete this Workspace?</p>
                        <a href="#" class="btn appButton linkBG justify-content-center mt-4 mx-auto" @click.prevent="deleteWorkspace()">Yes</a>
                        <a href="#" class="noAdd" @click.prevent="deleteWorkspaceId = null">No</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueDragResize from 'vue-drag-resize';
import app_watchlist from '../shared/app-watchlist';
// import chart_section from './home-elements/chart-section';
import chart_iq from "../shared/chart-iq";
import trading_view from "../shared/trading-view";
import positionList from '../shared/order/position-list'
import orderList from '../shared/order/order-list'
import tradeHistory from '../shared/order/trade-history'
import tradeLogs from '../shared/order/trade-logs'
import newsSection from './home-elements/news-section';
import buy_sell_tabing from './home-elements/buy-sell-tabing';
import EconomicCalendar from './home-elements/Economic-Calendar';
import depth_chart from './home-elements/depth-chart';
import price_alert_tab from './home-elements/price-alert-tab';
import { commonAllmixins } from '@/plugins/commonAll';
import { Const } from '@/plugins/vue-provider-cache/const.mod';
const product_type = process.env.product_type;
export default {
    name: 'app-custom-view',
    mixins: [commonAllmixins],
    data() {
        return {
            pageLoader: false,
            width: 0,
            height: 0,
            yAxis: 0,
            xAxis: 0,
            top: 0,
            left: 0,
            tradeBuySell: false,
            isToggled: false,
            currencyType: 'ALL',
            buySellType: 'buy',         
            editWatchlist: false,       
            delWatchlist: false,
            watchA : true,
            "loadChart" : "EURUSD"+product_type,
            mn:'EURUSD'+product_type,
            chartKeys: { 'key':"EURUSD"+product_type, 'mn':"EURUSD"+product_type},
            activeDiv: '',
            widgetsList:{},
            listIndex:['Watchlist','chart','position','order','history','trade_log','news','buy_sell','eco_cal','depth','alert'],
            bid :[],
            ask :[],
            floting : false,
            widgitActive : false,
            showCreateWorkSpace : false,
            createWorkSpaceSuccess : false,
            newWorkSpace : '',
            submitted : false,
            selectedWorkspace : { name:'', id: null },
            backupSelectedWorkspace : { name:'', id: null },
            lastUpdate: null,
            saveWorkSpaceCurrent:false,
            deleteWorkspaceId: null,
            changeToNewId: null,
            changeToDefault: false,
            editWorkspace: {},
            saveCurrentWork: false,

        }
    },
    components: {
            VueDragResize,
            appWatchlist:app_watchlist,
            // appChartsecssion: chart_section,
            chartIq: chart_iq,
            tradingView: trading_view,
            positionList,
            orderList,
            tradeHistory,
            tradeLogs,
            AppNewsSection: newsSection,
            AppBuySellTabing: buy_sell_tabing,
            EconomicCalendar,
            appDepthChart : depth_chart,
            priceAlertTab : price_alert_tab,
    },
    watch:{
    	loadChart(val){
    		this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].orderBook({symbol:val})
    		this.bid =[]
    		this.ask =[]
    	},
        chartKeys(value){
            this.mn = value.mn
            this.loadChart = value.key
        },
    	/*widgetsList(val){
    		console.log('------------------>')
    		localStorage.setItem('custom_widgets', window.btoa(JSON.stringify({'widgetsList':val,'listIndex':this.listIndex})));
    	},
    	listIndex(val){
    		localStorage.setItem('custom_widgets', window.btoa(JSON.stringify({'widgetsList':this.widgetsList,'listIndex':val})));
    	}*/
    },
    methods: {
        getDepthValue(type){
            try{
                let _that =  this
                if(type == 'buy'){
                    return this.orderBook[this.loadChart].buy.filter(val=> val.Rate <= _that.instruments[_that.loadChart].B).slice(0,10)
                }else if(type == 'sell'){
                    return this.orderBook[this.loadChart].sell.filter(val=> val.Rate >= _that.instruments[_that.loadChart].A).slice(0,10)
                }else{
                    return []
                }
            }catch(e){ return [] }
        },
        editSave(){
            let totalData = this.getRawData()
            totalData.view_mode.workSpace.forEach((val,index)=>{
                if(val.id == this.editWorkspace.id){
                    totalData.view_mode.workSpace[index]['name'] = this.editWorkspace.name
                }
            })
            this._runSetRawObject({ 'globalParams' : {'setting': totalData},'localParams' : {'parameter' : this} })
        },
        displayError(getMessage,type){
            this.$notify({
                group: 'foo',
                type: (type && type == null)?'error':type,
                text: getMessage,
                duration: 3000,
                closeOnClick: true
            });
        },
        rawObjectSaved(){
            if(this.deleteWorkspaceId){
                if(this.deleteWorkspaceId == this.selectedWorkspace.id){
                    this.goToDefault()
                }
                this.displayError('WorkSpace deleted Successfully','success')
                this.deleteWorkspaceId = null
            }
            if(this.showCreateWorkSpace){
                this.displayError('New WorkSpace have Created Successfully','success')
                if(this.changeToNewId){
                    this.changeWorkSpace(this.changeToNewId)
                }else{
                    this.selectedWorkspace = this.backupSelectedWorkspace
                    this.setlocal(true)
                }
                this.clearCreateWorkSpace()
                this.backupSelectedWorkspace = { name:'', id: null }
            }
            if(this.saveWorkSpaceCurrent || this.saveCurrentWork){
                this.displayError('WorkSpace Saved Successfully','success')
                this.saveWorkSpaceCurrent = false
                if(this.changeToNewId){
                    this.changeWorkSpace(this.changeToNewId)
                }else if(this.changeToDefault){
                    this.goToDefault()
                    this.changeToDefault = false
                }
            }
            if(Object.keys(this.editWorkspace).length > 0){
                this.displayError('WorkSpace Edited Successfully','success')
                this.selectedWorkspace.name = this.editWorkspace.name
                this.editWorkspace = {}
                this.setlocal(true)
            }
        },
        deleteWorkspace(){
            let id = this.deleteWorkspaceId
            let totalData = this.getRawData()
            totalData.view_mode.workSpace = totalData.view_mode.workSpace.filter(val=>val.id != id);
            this._runSetRawObject({ 'globalParams' : {'setting': totalData},'localParams' : {'parameter' : this} })
        },
        save(){
            if(this.workSpaceList().filter(val=>val.id == this.selectedWorkspace.id)[0]){
                // this.saveWorkSpaceCurrent = true
                this.saveCurrentWork = true
                this.saveCurrent()
            }else{
                this.openCreateWorkSpace()
            }
        },
        openCreateWorkSpace(){
            this.newWorkSpace = ''
            this.newWorkSpace = ''
            this.showCreateWorkSpace = true
            this.createWorkSpaceSuccess = false
        },
        clearCreateWorkSpace(){
            this.newWorkSpace = ''
            this.changeToNewId = null
            this.showCreateWorkSpace = false
            this.createWorkSpaceSuccess = false
        },
        saveCurrent(){
            let totalData = this.getRawData()
            totalData.view_mode.workSpace.forEach((val,index)=>{
                if(val.id == this.selectedWorkspace.id){
                    totalData.view_mode.workSpace[index]['data'] = this.widgetsList
                    totalData.view_mode.workSpace[index]['lastUpdate'] = this.lastUpdate
                }
            })
            this._runSetRawObject({ 'globalParams' : {'setting': totalData},'localParams' : {'parameter' : this} })
        },
        changeWorkSpace(newId,discardChanges){
            let previousId = this.selectedWorkspace['id']
            if(previousId == newId){ //chec
                return
            }
            if(newId){ //
                let getData = this.workSpaceList().filter(val=>val.id == newId)[0]
                if(getData){
                    if(this.saveActive() && !discardChanges){
                        this.changeToNewId = newId
                        this.save()
                    }else if(this.selectedWorkspace['id'] != getData.id){
                        this.changeToNewId = null
                        this.widgetsList = getData.data
                        this.selectedWorkspace['name'] = getData.name || ''
                        this.selectedWorkspace['id'] = getData.id || null
                        this.lastUpdate = getData.lastUpdate || null
                        this.setlocal(true)
                    }
                }
            }else{
                if( this.saveActive() && !discardChanges ){
                    this.changeToNewId = newId
                    this.changeToDefault = true
                    this.save()
                }else{
                    this.changeToDefault = false
                    this.changeToNewId = null
                    this.goToDefault()
                }
            }
        },
        saveActive(){ // active sabe button //check either workspace value is changed or not
            if(this.selectedWorkspace['id'] == null){        // default selected
                if(this.lastUpdate == null){ // and no change
                    return false
                }else{
                    return true
                }
            }else if(this.selectedWorkspace['id'] != null){  // previously selected a workspace
                let getData = this.workSpaceList().filter(val=>val.id == this.selectedWorkspace.id)[0]
                if(getData){
                    if(this.lastUpdate == getData.lastUpdate){
                        return false
                    }else{
                        return true
                    }
                }
                else{
                    return true  // data exist but not saved in cloud
                }
            }
        },
        goToDefault(){
            this.widgetsList = JSON.parse(JSON.stringify(this.defaultWorkSpaceList));
            this.selectedWorkspace = { name:'', id: null }
            this.lastUpdate = null
            this.setlocal(true)
        },
        workSpaceList(){
            try{
                return this.rawObject.view_mode.workSpace
            }catch(e){ return [] }
        },
        
        addWorkSpace(){
            let totalData = this.getRawData()
            let id = Date.parse(new Date())
            let lastUpdate = this.lastUpdate
            totalData.view_mode.workSpace.push({'name':this.newWorkSpace, 'data':this.widgetsList , 'id': id, 'lastUpdate': lastUpdate})
            let inputJson = {
                'globalParams' : {
                    setting: totalData
                },'localParams' : {'parameter' : this}
            }
            this.backupSelectedWorkspace.name = this.newWorkSpace
            this.backupSelectedWorkspace.id = id
            this._runSetRawObject(inputJson)
        },
        CheckMaxWorkSpace(){
            return false;
        },
    	close(key){
    		this.widgetsList[key].active = false
    		this.setlocal()
    	},
        maximize(key){
            if(this.widgetsList[key].max){
                this.widgetsList[key]['max'] = false
                this.widgetsList[key].t = 0
                this.widgetsList[key].l = 0
            }else{
                this.widgetsList[key]['max'] = true
            }
            this.setlocal()
        },
        isActive(key){
            if(this.widgitActive){
                return this.widgetsList[key].active
            }else{
                return false
            }
        },
    	getWidth(key){
    		if(this.widgetsList[key].max){
                return $('#app-custom-view').innerWidth();
    		}else{
				return this.widgetsList[key].w
            }
    	},
        getHeight(key){
            if(this.widgetsList[key].max){
                return $('#app-custom-view').innerHeight();
            }else{
                return this.widgetsList[key].h
            }
        },
        getTop(key){
            if(this.widgetsList[key].max){
                return 0
            }else{
                return this.widgetsList[key].t
            }
        },
        getLeft(key){
            if(this.widgetsList[key].max){
                return 0
            }else{
                return this.widgetsList[key].l
            }
        },
        getWidgit(key){
            if(!this.widgetsList[key].active){
                /*let l=0
                this.widgetsList.filter(val=>val.active).sort((a, b) => a.l - b.l);
                for()*/
                this.widgetsList[key].active = true
                this.widgetsList[key].max = false
                this.widgetsList[key].t = 0
                this.widgetsList[key].l = 0
            }
            this.clickeed(key,true)
        },
    	getIndex(val){
    		return this.listIndex.indexOf(val)
    	},
        chkDiv(val){
            return this.activeDiv == val
        },
        onDeact(val){
            if(this.activeDiv == val){
                return this.activeDiv = ''
            }
        },
        clickeed(val,saveLoacal){
            this.listIndex.splice(this.listIndex.indexOf(val),1);
            this.listIndex.push(val);
            if(!saveLoacal){
                this.setlocal(true)
            }else{ this.setlocal() }
            this.activeDiv = val
        },
        appResize(event,key){
            let isNotResized = false
            if(this.widgetsList[key].w == event.width && this.widgetsList[key].h == event.height && this.widgetsList[key].t == event.top && this.widgetsList[key].l == event.left){
                isNotResized = true
            }
            this.widgetsList[key].w = event.width;
            this.widgetsList[key].h = event.height;
            this.widgetsList[key].t = (event.top >= 0)?event.top:0;
            this.widgetsList[key].l = (event.left >= 0)?event.left:0;
            this.setlocal(isNotResized)
        },
        isFloating(key){
            if(this.widgetsList[key].max){
                return false
            }else{
                return !this.floting
            }
        },
        setlocal(changeLastUpdate){
            if(!changeLastUpdate) {this.lastUpdate = Date.parse(new Date())}
            let setData ={
                'workspace' : {'widgetsList':this.widgetsList,'listIndex':this.listIndex},
                'selectedWorkspace' : this.selectedWorkspace,
                'lastUpdate' : this.lastUpdate
            }
            localStorage.setItem('custom_widgets', window.btoa(JSON.stringify(setData)));
        },
    },
    computed:{
		instruments() {
    	    try {                    
	            this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
	            return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
	        } catch (ex) {                
	            return []
	        }
	    },
        contractSize(){
            try{
                return this.currencyPairs.filter(val=>val.isinid.includes( this.symbol))[0].market_ContractSize || 100000
            }catch(e){ return 100000 }
        },
    },
    created(){
    	let _that =  this
        
    	// this._runGetNewsData({'globalParams' : {} ,'localParams' : {'parameter' : this}})custom_widgets
    	if(localStorage.getItem('custom_widgets')){
    		let data = JSON.parse(window.atob(localStorage.getItem('custom_widgets')))
            if(data.workspace){
                if(data.workspace.widgetsList){
                    this.widgetsList = data.workspace.widgetsList}
                if(data.workspace.listIndex){this.listIndex = data.workspace.listIndex}
            }else{
                this.widgetsList = JSON.parse(JSON.stringify(this.defaultWorkSpaceList))
            }
            if(data.selectedWorkspace){ this.selectedWorkspace = data.selectedWorkspace }
            if(data.lastUpdate){ this.lastUpdate = data.lastUpdate }
    	}else{
            this.widgetsList = JSON.parse(JSON.stringify(this.defaultWorkSpaceList))
        }
        setTimeout(function(){ _that.widgitActive = true }, 1000);
    	setInterval(function(){
    		/*if(_that.orderBook[_that.loadChart] && _that.orderBook[_that.loadChart].buy &&  _that.orderBook[_that.loadChart].sell){
	    		let data = _that.orderBook[_that.loadChart]*/
            if(_that.getDepthValue('buy').length && _that.getDepthValue('sell').length){
                let bid = _that.getDepthValue('buy').map(val=>[val.Rate,val.Quantity])
                let ask = _that.getDepthValue('sell').map(val=>[val.Rate,val.Quantity])
		    	if(bid.length > 0 && ask.length > 0){
		    		// console.log('bid ask change')
		    		_that.bid = bid
		    		_that.ask = ask
		    		try{
		    			_that.$refs.depth_chart.dataChange()
		    		}catch(e){}
		    	}
    		}else{
	    		try{
    				_that.$store.getters[Const.GET_PROVIDERS]['priceFeed'].seeders['S_PF_PF'].orderBook({'symbol':_that.loadChart})
		    	}catch(e){}
    		}
    	}, 5000);
    },
    mounted() {
        const _that = this
        /*$(document).on("click", function(event){
            if(!$(event.target).closest('.openBuySell').length){
                _that.buySell = ''
                _that.tradeBuySell = false
            }
        });
        $('.vdr-stick').on("click", function(e){
            console.log('-----------------------',e,$($($($(e.currentTarget)[0].parentElement)[0].firstChild)[0].firstChild))
            // console.log('-----------------------',e,$(e.currentTarget[0].parentElement.childNodes[0].childNodes[0]))
            $($($($(e.currentTarget)[0].parentElement)[0].firstChild)[0].firstChild).click();
        });*/
    }
}
</script>
<style>
	.topMazimize{
		z-index: 999;
	}
	.topMazimize .justify-content-end{
		z-index: 999;
	}
</style>


// WEBPACK FOOTER //
// src/components/website/user/custom-view.vue